// @ts-nocheck
import PropTypes from 'prop-types';
import { Children } from 'react';

const AnalyticsStore = ({ children }) => Children.only(children);

AnalyticsStore.propTypes = {
    data: PropTypes.object.isRequired,
};

export default AnalyticsStore;
